import type { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/utils';
import { Text } from '../../text';

/**
 * Tableセルコンポーネント
 */
type TableCellProps = ComponentPropsWithRef<'td'> & {
  rowSpan?: number;
  colSpan?: number;
};

export const TableCell = ({
  className,
  ref,
  rowSpan,
  colSpan,
  children,
  ...props
}: TableCellProps) => (
  <td
    ref={ref}
    rowSpan={rowSpan}
    colSpan={colSpan}
    className={cn(
      'h-12 border-border-strength1 align-middle [&:has([role=checkbox])]:pr-0',
      'p-2',
      'border-r last:border-r-0',
      className,
    )}
    {...props}
  >
    <div className="flex items-center">
      {typeof children === 'string' ? <Text as="span">{children}</Text> : children}
    </div>
  </td>
);
